<template>
    <div>
        <header class="bg-surface-secondary">
            <div class="container-fluid max-w-screen-xl">
                <div class="row g-0">
                    <div class="col ps-4 pt-4">
                        <h1 class="h2">{{ user.name }}</h1>
                    </div>
                </div>
                <div class="border-bottom pt-6">
                    <v-tabs v-model="tab">
                        <v-tab :key="'profile'">Cuenta</v-tab>
                        <v-tab :key="'contact'">Contacto y dirección</v-tab>
                        <v-tab :key="'settings'">Facturación electrónica</v-tab>
                        <v-tab :key="'notifications'">Notificaciones</v-tab>
                    </v-tabs>
                </div>
            </div>
        </header>
        <main class="py-6 bg-surface-secondary">
            <div class="container-fluid">
                <account v-if="tab === 0"/>
                <contact v-if="tab === 1"/>
                <invoice v-if="tab === 2"/>
                <notifications v-if="tab === 3"/>
            </div>
        </main>
    </div>
</template>
<script>
import Account from './tabs/Account'
import Contact from './tabs/Contact'
import Invoice from './tabs/Invoice'
import Notifications from './tabs/Notifications'
import { mapGetters } from 'vuex'
export default {
    components: { Account, Contact, Invoice, Notifications },
    computed: {
        ...mapGetters([
            'user',
        ])
    },
    data(){
        return {
            tab: Number(localStorage.getItem('tab_profile') | 0),
        }
    }
}
</script>